import React from 'react';
import { SvgIcon } from '@material-ui/core';
import { ReactComponent as Check } from '@lifesize/ux-assets/vectors/svgIcons/check.svg';

const CheckIcon = () => <SvgIcon color="primary" component={Check} />;

export default CheckIcon;
